<div class="modal-container">
  <div class="modal-header" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
    <h5 style="padding: 0.9rem;" *ngIf="data?.type === 'tranunion'">Credit Bureau Information</h5>
    <h5 style="padding: 0.9rem;" *ngIf="data?.type === 'workdrive'">Client Documents</h5>
    <button mat-icon-button mat-dialog-close aria-label="Close dialog" style="background-color: rgba(0, 0, 0, 0);" class="custom-mat-field">
        <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <app-transunion *ngIf="data?.type === 'tranunion'"></app-transunion>
    <app-workdrive *ngIf="data?.type === 'workdrive'"></app-workdrive>
  </div>
</div>